import { useSearchParams } from 'next/navigation';

export function useQuery(): URLSearchParams {
  const searchParams = useSearchParams();
  return new URLSearchParams(searchParams);
}

export default useQuery;
